export const STORE_SERVICES = {
  DINE_IN: 'dine_in',
  RESERVATION: 'reservations',
  INTERNAL_RESERVATION: 'internal_reservations',
  ONLINE_ORDERING: 'online_ordering',
  CATERING: 'catering',
  TERRACE: 'terrace',
};

export const PaymentMethodsEnum = {
  Cash: 'cash',
  InStoreCard: 'in_store_card',
  Online: 'online',
};

export const DIETARY_ATTRIBUTES = {
  VEGETARIAN: 'vegetarian',
  VEGAN: 'vegan',
  HALAL: 'halal',
  GLUTEN_FREE: 'gluten_free',
  DAIRY_FREE: 'dairy_free',
  SPICY: 'spicy',
};
